import FooterSection from "assets/Footer";
import QuickAddDrawer from "components/quickAddDrawer";
import "flowbite";
import useFlashSaleData from "hook/useFlashSaleData";
import { useEffect, useRef, useState } from "react";
import { HiShoppingCart } from "react-icons/hi";
import { TbCurrencyTaka } from "react-icons/tb";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../assets/Navbar";
import useAllFlashProducts from "hook/useAllFlashProducts";
import { FaCartPlus } from "react-icons/fa";
import StockOut from "components/stockOut";
import ScreenScrollToTop from "../components/ScreenScrollToTop";
import HotOfferShimmer from "../components/shimmer/HotOfferShimmer";
import NoDataView from "../components/noDataView";
import { getCartItems, setCartItems } from "utils/cartStorage";

const HotOffer = () => {
  const navigate = useNavigate();
  const tabs = ["আজকের সেরা ডিল আমাদের শপে"];
  const { flashSaleData, loading } = useFlashSaleData();
  const [timeLeft, setTimeLeft] = useState(0);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { allProducts, loading1, error } = useAllFlashProducts();
  const [visibleCount, setVisibleCount] = useState(12);
  const loadMoreRef = useRef(null);
  const [isVisible, setIsVisible] = useState(true);
  const flashOfferProducts = allProducts.filter(
    (item) => item.flashOffer === 1,
  );
  const productsToShow = flashOfferProducts.slice(0, visibleCount);
  const hasMore = visibleCount < flashOfferProducts.length;

  const addToCart = (item) => {
    const existingItems = getCartItems();

    const key = item.item_id || item.title;
    const existingIndex = existingItems.findIndex(
      (p) => (p.item_id || p.title) === key,
    );

    const firstVariant = item.variants?.[0] || {};

    const colorArray = item.color
      ? item.color.split(",").map((s) => s.trim())
      : [];

    const sizeArray = item.size
      ? item.size.split(",").map((s) => s.trim())
      : [];

    const selectedColor = colorArray[0] || "";
    const selectedSize = sizeArray[0] || "";
    const selectedTitle = firstVariant.title || "";
    const selectedPrice = firstVariant.flashPrice || 0;

    // ✅ FIRE TAG HERE
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: "add_to_cart",
      ecommerce: {
        currency: "BDT",
        value: selectedPrice,
        items: [
          {
            item_id: item.item_id,
            item_name: firstVariant.title,
            price: selectedPrice,
            item_category: item.catalogue_title,
            quantity: 1,
          },
        ],
      },
    });

    console.log("add_to_cart fired");

    if (existingIndex !== -1) {
      existingItems[existingIndex] = {
        ...existingItems[existingIndex],
        quantity: (existingItems[existingIndex].quantity || 1) + 1,
        selectedColor,
        selectedSize,
        selectedTitle,
        selectedPrice,
      };
    } else {
      existingItems.push({
        ...item,
        quantity: 1,
        selectedColor,
        selectedSize,
        selectedTitle,
        selectedPrice,
        selectedVariant: firstVariant,
      });
    }

    setCartItems(existingItems);
  };

  useEffect(() => {
    if (!hasMore) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setVisibleCount((prev) =>
            Math.min(prev + 12, flashOfferProducts.length),
          );
        }
      },
      {
        rootMargin: "100px",
      },
    );

    const currentRef = loadMoreRef.current;
    if (currentRef) observer.observe(currentRef);

    return () => {
      if (currentRef) observer.unobserve(currentRef);
    };
  }, [hasMore, flashOfferProducts.length]);

  useEffect(() => {
    if (flashSaleData) {
      if (flashSaleData.available === false) {
        setIsVisible(false);
        return;
      }
      setIsVisible(true);
      setTimeLeft(Math.floor(flashSaleData.remaining_seconds));
    }
  }, [flashSaleData]);

  useEffect(() => {
    if (timeLeft <= 0) {
      setIsVisible(false);
      return;
    }

    const timer = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  const formatTime = (totalSeconds) => {
    totalSeconds = Math.max(0, Math.floor(totalSeconds));
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return { days, hours, minutes, seconds };
  };

  const { days, hours, minutes, seconds } = formatTime(timeLeft || 0);
  if (loading1 || loading) return <HotOfferShimmer />;

  return (
    <div className="bg-gray-100">
      <Navbar />
      <div className="bg-gray-100">
        <div className="container mx-auto pt-5 my-5 ">
          <h1 className="text-backgroundColor lg:text-[44px] text-2xl font-bold text-center md:my-5 my-3">
            অবিশ্বাস্য মূল্য ছাড়!!
          </h1>
          <div className=" mx-auto px-4 md:py-6 py-4">
            <div className="flex space-x-6 border-b border-gray-200 justify-center mb-5">
              {tabs.map((tab) => (
                <p
                  key={tab}
                  className="pb-2 px-4 font-semibold tracking-wide transition-all border-b-2 border-backgroundColor text-black md:text-base text-md"
                >
                  {tab}
                </p>
              ))}
            </div>

            <div className="container mx-auto px-4 sm:px-6 md:px-10">
              {/* <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mx-1 md:mx-5"> */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mx-1 md:mx-5 justify-center justify-items-center">
                <p className="w-[150px] md:w-[200px] lg:w-[250px] h-[80px] md:h-[100px] lg:h-[120px] px-3 py-3 text-center font-bold bg-white rounded text-lg md:text-2xl lg:text-3xl flex flex-col items-center justify-center">
                  {days}
                  <br />
                  দিন
                </p>
                <p className="w-[150px] md:w-[200px] lg:w-[250px] h-[80px] md:h-[100px] lg:h-[120px] px-3 py-3 text-center font-bold bg-white rounded text-lg md:text-2xl lg:text-3xl flex flex-col items-center justify-center">
                  {hours}
                  <br />
                  ঘন্টা
                </p>
                <p className="w-[150px] md:w-[200px] lg:w-[250px] h-[80px] md:h-[100px] lg:h-[120px] px-3 py-3 text-center font-bold bg-white rounded text-lg md:text-2xl lg:text-3xl flex flex-col items-center justify-center">
                  {minutes}
                  <br />
                  মিনিট
                </p>
                <p className="w-[150px] md:w-[200px] lg:w-[250px] h-[80px] md:h-[100px] lg:h-[120px] px-3 py-3 text-center font-bold bg-white rounded text-lg md:text-2xl lg:text-3xl flex flex-col items-center justify-center">
                  {seconds}
                  <br />
                  সেকেন্ড
                </p>
              </div>
            </div>
            {productsToShow.length === 0 ? (
              <NoDataView title="শীঘ্রই নতুন পণ্যে অফার দেওয়া হবে" />
            ) : (
              <div className="container mx-auto px-4 sm:px-6 md:px-10 mt-10">
                <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 2xl:grid-cols-4 gap-4">
                  {productsToShow
                    .filter((item) => item.hideStatus === "available")
                    .map((item, index) => {
                      const isOutOfStock = item.status === "unavailable";
                      const firstVariant = item.variants?.[0] || {};
                      const firstImage = firstVariant.images?.[0]?.thumb || "";

                      const selectedTitle = firstVariant.title || "-";
                      const selectedPrice = firstVariant.flashPrice || 0;
                      const selectedDiscount = firstVariant.discount || 0;
                      const originalPrice = selectedDiscount || 0;
                      const flashPrice = selectedPrice || 0;

                      const discountPercent =
                        originalPrice > 0
                          ? Math.ceil(
                              ((originalPrice - flashPrice) / originalPrice) *
                                100,
                            )
                          : 0;
                      return (
                        <div
                          key={`${item.item_id}-${index}`}
                          className={`relative flex flex-col flex-shrink-0 lg:w-[340px] md:w-[240px] max-md:basis-[47%] bg-white rounded-[10px] overflow-hidden transition-transform duration-200 
                                        ${isOutOfStock ? "cursor-not-allowed opacity-40" : ""}
                                    `}
                        >
                          {isOutOfStock && <StockOut />}
                          <Link
                            to={`/details/${item.catalogue}/${item.item_id}`}
                          >
                            <div className="relative group aspect-product-desktop w-full overflow-hidden">
                              <img
                                src={`https://backend.nuhababy.com/${firstImage}`}
                                alt={selectedTitle}
                                loading={index < 4 ? "eager" : "lazy"}
                                fetchPriority={index === 0 ? "high" : "auto"}
                                decoding="async"
                                width={315}
                                height={460}
                                className="transition-transform duration-1000 h-full object-cover ease-in-out transform w-full group-hover:scale-105 cursor-pointer rounded-t-[10px]"
                              />
                              {/* {discountPercent > 0 && (
                                <div className="absolute top-2 left-2">
                                  <div className="relative md:w-20 w-16 md:h-8 h-6 flex items-center justify-center rounded-md bg-red-500 text-white font-bold md:text-sm text-[10px] z-10">
                                    {discountPercent}% OFF
                                  </div>
                                </div>
                              )} */}
                              {discountPercent > 0 && (
                                <div className="absolute top-0 left-0 w-20 h-20 overflow-hidden z-10">
                                  <div className="absolute top-[18px] -left-[28px] rotate-[-45deg] bg-red-500 text-white text-[10px] md:text-xs font-bold w-32 text-center py-1 shadow-md">
                                    {discountPercent}% OFF
                                  </div>
                                </div>
                              )}
                              {firstVariant.freeVariantDelivery === 1 && (
                                <div className="absolute top-2 right-2">
                                  <div className="flex items-center gap-1 px-2 md:h-8 h-6 bg-blue-600  text-white rounded-md text-[10px] md:text-xs font-semibold shadow">
                                    🚚 <span>ফ্রি ডেলিভারী</span>
                                  </div>
                                </div>
                              )}
                            </div>
                          </Link>
                          <div className="md:px-3 p-2 flex flex-col flex-grow">
                            <div className="text-black hover:text-[#222836] hover:opacity-60 font-medium tracking-wide mb-1 text-sm whitespace-nowrap overflow-hidden truncate">
                              {item?.mainTitle}
                            </div>
                            <div className="text-black hover:text-[#222836] hover:opacity-60 tracking-wide mb-1 text-xs whitespace-nowrap overflow-hidden truncate">
                              {selectedTitle}
                            </div>
                            <div className="flex pb-2">
                              <div className="relative inline-flex items-center text-gray-400 text-sm mr-2">
                                <span className="flex items-center">
                                  <p>{selectedDiscount}</p>
                                  <TbCurrencyTaka className="font-semibold" />
                                </span>
                                <div className="absolute left-0 right-0 top-1/2 h-[1px] bg-gray-400"></div>
                              </div>
                              <div className="flex text-[#265fc9] items-center text-sm">
                                <p className="font-bold">{selectedPrice}</p>
                                <TbCurrencyTaka className="font-semibold" />
                              </div>
                            </div>

                            {!isOutOfStock && (
                              <div className="flex gap-2 my-1 mt-auto">
                                <button
                                  lang="bn"
                                  onClick={(e) => {
                                    addToCart(item);
                                    navigate("/orderDetails");
                                  }}
                                  className="md:text-base text-sm flex-1 text-white bg-backgroundColor border border-darkBgColor rounded-md md:px-4 px-2 py-1 md:font-bold font-semibold flex justify-center items-center"
                                >
                                  অর্ডার করুন
                                </button>
                                <button
                                  type="button"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    addToCart(item);
                                    setDrawerOpen(true);
                                  }}
                                  className="md:px-3 px-2 rounded-md border text-darkBgColor py-1"
                                >
                                  <span className="group-hover:hidden md:text-base text-sm">
                                    <FaCartPlus />
                                  </span>
                                  <HiShoppingCart className="hidden group-hover:block w-5 h-5" />
                                </button>
                              </div>
                            )}
                            <QuickAddDrawer
                              isOpen={drawerOpen}
                              onClose={() => setDrawerOpen(false)}
                            />
                          </div>
                        </div>
                      );
                    })}
                </div>
                {hasMore && (
                  <div
                    ref={loadMoreRef}
                    className="h-16 mt-10 flex justify-center items-center"
                  >
                    <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-[#265fc9]"></div>
                  </div>
                )}
              </div>
            )}

            <QuickAddDrawer
              isOpen={drawerOpen}
              onClose={() => setDrawerOpen(false)}
            />
          </div>
        </div>
      </div>
      <FooterSection />
      <ScreenScrollToTop />
    </div>
  );
};

export default HotOffer;
